import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgListButton = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 18,
	viewBox: "0 0 20 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 20,
			height: 3,
			rx: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 10,
			width: 20,
			height: 3,
			rx: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 5,
			width: 20,
			height: 3,
			rx: 1
		}),
		/* @__PURE__ */ _jsx("rect", {
			y: 15,
			width: 20,
			height: 3,
			rx: 1
		})
	]
});
export default SvgListButton;
